import React, { useState } from 'react';
import Datatable from '../../components/shared/datatable/Datatable';
import { useGetAllFaqsQuery, useToggleFaqActiveMutation } from '../../app/faqApi/faqApi';
import { formatDateToMDY } from '../../helpers/Utils';
import Button from '../../components/shared/buttons/button';
import AddFaqModal from '../../components/shared/modalContent/AddFaqModal';
import { MdOutlineEditNote } from "react-icons/md";
import { useParams } from 'react-router';
import { Form, Spinner } from 'react-bootstrap';
import toast from 'react-hot-toast';
import CommonBreadcrumb from '../../components/shared/breadcrumb/CommonBreadcrumb';

const Faq = () => {
  const { id } = useParams();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedFaqId, setSelectedFaqId] = useState(null);
  const [loadingToggles, setLoadingToggles] = useState({});

  const { data: faqData, isLoading: faqIsLoading } = useGetAllFaqsQuery(id);
  const [toggleFaqActive] = useToggleFaqActiveMutation();

  const handlePageChange = (newPage) => setPage(newPage);

  const handleSearch = (value) => {
    setSearch(value);
    setPage(1);
  };

  const handleEditFaq = (row) => {
    setSelectedFaqId(row._id);
    setShowModal(true);
  };

  const handleAddFaq = () => {
    setSelectedFaqId(null);
    setShowModal(true);
  };

  const handleToggle = async (faqId) => {
    setLoadingToggles((prev) => ({ ...prev, [faqId]: true }));
    try {
      await toggleFaqActive(faqId).unwrap();
      toast.dismiss();
      toast.success('FAQ status changed successfully');
    } catch (error) {
      toast.dismiss();
      toast.error(error?.data?.message || 'Something went wrong');
      console.error("Toggle failed", error);
    } finally {
      setLoadingToggles((prev) => ({ ...prev, [faqId]: false }));
    }
  };

  const columns = [
    {
      label: 'Question',
      accessor: 'question',
      cell: ({ row }) => (
        <>
          <h5 className='d-block'>{row?.title}</h5>
          <span className='w-75 d-block'>{row?.content}</span>
        </>
      ),
    },
    {
      label: 'Created At',
      accessor: 'createdAt',
      cell: ({ row }) => <>{formatDateToMDY(row?.createdAt)}</>,
    },
    {
      label: 'Action',
      accessor: 'action-edit',
      cell: ({ row }) => (
        <Button
          className={'borderedBtn px-0'}
          size="xs"
          icon={<MdOutlineEditNote onClick={() => handleEditFaq(row)} size={24} />}
        />
      ),
    },
    {
      label: '',
      accessor: 'action-toggle',
      cell: ({ row }) => {
        const isLoadingToggle = !!loadingToggles[row._id];
        return (
          <Form.Check
            type='switch'
            id={`faq-toggle-${row._id}`}
            label={
              isLoadingToggle ? (
                <Spinner animation="border" size="sm" />
              ) : row?.isActive ? 'Active' : 'Inactive'
            }
            checked={row?.isActive}
            disabled={isLoadingToggle}
            onChange={() => handleToggle(row._id)}
          />
        );
      },
    },
  ];

  const breadcrumbItems = [
    { label: "FAQ's Categories", path: '/faq-categories' },
    { label: `User Details - ${id}` },
  ];

  return (
    <>
      <CommonBreadcrumb items={breadcrumbItems} />
      <div className='d-flex justify-content-between align-items-center mb-3'>
        <h6 className='mb-0 setting-headings'>FAQ's List</h6>
        <Button label="Add FAQ" size="xs" onClick={handleAddFaq} />
      </div>

      <Datatable
        tableData={faqData}
        columns={columns}
        page={page}
        onPageChange={handlePageChange}
        isLoading={faqIsLoading}
        showPegination={true}
        showFilter={false}
        onFilterSearch={handleSearch}
      />

      <AddFaqModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        setShow={setShowModal}
        faqId={selectedFaqId}
        categoryId={id}
      />
    </>
  );
};

export default Faq;
